
import { i18nText } from '@/locales';

import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Button, FormModel, Input, List, Menu, Modal, Select, Table, Tabs} from "ant-design-vue";
import {mixins} from "vue-class-component";
import {SimpleProxyForm} from "@/UI/components/Helpers/SimpleProxyForm";
import {FormRules, LoyaltyCertTypeFormData} from "@/form/loyalty/loyaltyCertType/LoyaltyCertType";
import {LoyaltyCertTypeStore} from "@/store/modules/Loyalty/Cert/LoyaltyCertType";
import {AppStateStore} from "@/store/modules/appState";
import {serviceswithQuillwortMix} from "@/UI/mixins/Store/serviceswithQuillwortMix";
import {ServiceStore} from "@/store/modules/Services";
import {IServicesListItem} from "@/entity/services/services.types";
import {RouterNameEnum} from "@/router/router.types";
import {DataEntity} from "@/entity/warehouse/Products/Products.types";
import {getStudioId} from "@/UI/lib/state";
import {ProductsStockStore} from "@/store/modules/Warehouse/ProductsStock";
import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import {ServiceCategoryMix} from "@/UI/mixins/Service/ServiceCategoryMix";
import {TreeTransfer} from "@/UI/lib/calculte";
import {showNotification} from "@/UI/lib/messages";
import PageTitle from "@/UI/components/common/PageTitle.vue";

@Component({
    components: {
        BaseDataForm,
        PageTitle,
        "a-button": Button,
        "a-menu-item": Menu.Item,
        "a-list-item": List.Item,
        "a-list-item-meta": List.Item.Meta,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-table": Table,
        "a-input": Input,
        "a-tab": Tabs,
        "a-tab-pane": Tabs.TabPane,
        "a-form-model": FormModel,
        "a-form-model-item": FormModel.Item,
        "a-modal": Modal,
    },
})
export default class loyaltyTypeAdd extends mixins(
    SimpleProxyForm,
    serviceswithQuillwortMix,
    ServiceCategoryMix,
) {
    @Prop() mode!: number;
    newForm = new LoyaltyCertTypeFormData();
    saving = false;
    productsData: any[] = [];
    dtreeProductsData: any[] = [];
    Rules = FormRules;
    dataServices: Array<IServicesListItem> = [];
    dataProducts: Array<DataEntity> = [];
    title = i18nText("Редактирование типа сертификата")
    servicesModal: boolean = false;
    productsModal: boolean = false;
    servicesTree = new TreeTransfer();
    serviceProducts = new TreeTransfer();

    serviceChange(index: any): void {
        const data = index["key"].split("-");

        function checkId(id: number): boolean {
            return id === Number(data[0]);
        }

        if (this.newForm.services_id && !this.newForm.services_id.find(checkId)) {
            this.newForm.services_id.push(Number(data[0]));
        }
    }

    productsChange(index: any): void {
        const data = index["key"].split("-");
        function checkId(id: number): boolean {
            return id === Number(data[0]);
        }

        if (this.newForm.products_id && !this.newForm.products_id.find(checkId)) {
            this.newForm.products_id.push(Number(data[0]));
        }
    }

    deleteProduct(product: number): void {
        if (this.newForm.products_id) {
            this.newForm.products_id.splice(
                this.newForm.products_id.findIndex(function (productIndex) {
                    return productIndex === product;
                }),
                1,
            );
        }
    }

    deleteService(service: number): void {
        if (this.newForm.services_id) {
            this.newForm.services_id.splice(
                this.newForm.services_id.findIndex(function (serviceIndex) {
                    return serviceIndex === service;
                }),
                1,
            );
        }
    }

    serviceName(id: number): any {
        if (this.findCategoryData(Number(id))) {
            const data = this.findCategoryData(Number(id));
            return data["name"];
        } else return null;
    }

    productName(id: number): any {
        return this.productsData.find(product => product.id === id)?.name;
    }

    modalCancel(mode: number): void {
        if (mode === 0) {
            this.servicesModal = false;
        }
        if (mode === 1) {
            this.productsModal = false;
        }
    }

    modalOk(mode: number): void {
        if (mode === 0) {
            //console.log("servicesTree " + this.servicesTree.parseData());
            this.newForm.services_id = this.servicesTree.parseData();
            this.servicesModal = false;
        }
        if (mode === 1) {
            this.newForm.products_id = this.serviceProducts.parseData();
            this.productsModal = false;
        }
    }

    onSelect(selectedKeys: any, info: any) {
        console.log("selected", selectedKeys, info);
    }

    onServiceCheck(checkedKeys: any, info: any): void {
        console.log("onCheck", checkedKeys, info);
        this.servicesTree.setValue(checkedKeys);
    }

    onProductsCheck(checkedKeys: any, info: any): void {
        this.serviceProducts.setValue(checkedKeys);
    }

    @Watch("$store.state.appState.sendDelete", {immediate: false})
    async ButtonDelete(value: boolean): Promise<void> {
        if (!value) return;
        try {
            await LoyaltyCertTypeStore.delete({id: this.newForm.id as any}).then((response) => {
                showNotification(i18nText("Удаление типа сертификата -"), response);
            })
        } catch (e) {
            console.error(e)
        } finally {
            AppStateStore.setDelete(false);
            await Vue.router.push({
                name: RouterNameEnum.LoyaltyCertType,
                params: {
                    Studio: getStudioId(this),
                },
            });
        }
    }

    @Watch("$store.state.appState.sendCancel", {immediate: false})
    async ButtonCancel(value: boolean): Promise<void> {
        if (!value) return;
        AppStateStore.setCancel(false);
        await Vue.router.push({
            name: RouterNameEnum.LoyaltyCertType,
            params: {
                Studio: getStudioId(this),
            },
        });
    }

    @Watch("$store.state.appState.sendSubmit", {immediate: true})
    ButtonSubmit(value: boolean): void {
        if (!value || this.saving) return;
        (this.$refs.certTypeForm as FormModel).validate(async (valid) => {
            if (!valid) { AppStateStore.setSubmit(false); return; }
            this.saving = true;
            try {
                const result = this.mode === 0 ? await LoyaltyCertTypeStore.create(this.newForm) : await LoyaltyCertTypeStore.update(this.newForm);
                this.$message.open({type: result.status ? 'success' : 'error', content: result.response});
                if (result.status) await Vue.router.push({name: RouterNameEnum.LoyaltyCertType, params: {Studio: getStudioId(this)}});
            } catch (error) {
                this.$message.error(error.response?.data?.errors ? Object.values(error.response.data.errors).flat().join(' ') : error.response?.data?.message || error.message);
            } finally {
                this.saving = false;
                AppStateStore.setSubmit(false);
            }
        });
    }

    async getData(): Promise<void> {
        const salon_id = getStudioId(this);
        await ServicesCategoryStore.fetchAll({filter: {salon_id}, limit: -1});
        const categories = ServicesCategoryStore.serviceCategory?.data || [];
        this.servicesData = categories.flatMap(category => category.services || []);
        this.dtreeServicesData = categories.map(category => ({title: category.name, key: String(category.id), children: (category.services || []).map(service => ({title: service.name, key: 'service-' + service.id}))}));
        await ProductsStockStore.fetchAll({filter: {salon_id}, limit: -1});
        this.productsData = (ProductsStockStore.items?.data || []).map(product => ({...product.nomenclature, id: product.id, name: product.nomenclature.name + ' (' + (product as any).store.name + ')'}));
        this.dtreeProductsData = this.productsData.map(product => ({title: product.name, key: 'product-' + product.id}));
    }

    async created(): Promise<void> {
        try {

            if (this.$props['mode'] === 0) this.title = i18nText("Создание типа сертификата")
            if (this.$route.query.readonly && !!this.$route.query.readonly) {
                this.title = i18nText("Просмотр типа сертификата")
            }
            this.newForm.salon_id = getStudioId(this);
            this.formReady = false;
            if (this.mode === 1) {
                await LoyaltyCertTypeStore.fetchData({filter: {id: this.$router.currentRoute.params["id"]}});
                if (LoyaltyCertTypeStore.loyaltyCertType) {
                    const data = LoyaltyCertTypeStore.loyaltyCertType;

                    if (data.products !== null) {
                        data.products.forEach((product: any) => {
                            if (this.newForm.products_id) {
                                this.newForm.products_id.push(product['id'])
                            }
                        });
                    }
                    if (data.services !== null) {
                        data.services.forEach((service: any) => {
                            if (this.newForm.services_id) {
                                this.newForm.services_id.push(service['id'])
                            }
                        })
                    }

                    this.newForm.id = data["id"];
                    this.newForm.name = data["name"];

                    this.newForm.writeoff_id = data["writeoff_id"];
                    this.newForm.salon_id = data["salon_id"];
                    this.newForm.balance = data["balance"];
                    this.newForm.coverage = data["coverage"];
                    this.newForm.period = data["period"];

                }
            }
            await this.getData();
            this.formReady = true;
        } catch (e) {
            console.log(e.message);
        } finally {
            AppStateStore.setSubmit(false);
            this.formReady = true;
        }
    }
}
